<template>
  <v-layout row wrap fill-height>
    <v-toolbar app dense color="primary">
      <v-toolbar-title>Suburban Serv - Admin</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="logout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>

    <v-bottom-nav :active.sync="activeBtn" :value="true" color="primary" height="50" fixed>
      <v-btn flat color="white" value="Customers">
        <span>Tasks</span>
        <v-icon>mdi-calendar-check</v-icon>
      </v-btn>

      <v-btn flat color="white">
        <span>Meeting</span>
        <v-icon>mdi-meetup</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      activeBtn: "null"
    };
  },
  methods: {
    logout() {
      this.$router.push(`/`);
    }
  }
};
</script>
